import api from '@/api'
import store from '@/store'
import moment from 'moment';
const FileSaver = require('file-saver')

export default {
  async createPairingForCampaign(campaignID, influencerList) {
    let data = {
      campaignID: campaignID,
      influencers: influencerList
    }
    try {
      let response = await api.request('post', `/api/v1/pairings/campaigns/`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },

  async getPairedInfluencersByCampaign(campaignID, refresh = false) {
    try {
      let response = await api.request('get', `/api/v1/pairings/influencers?campaign=${campaignID}&refresh=${refresh}`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },

  async getAccuredCogs() {
    try {
      let response = await api.request('get', `/api/v1/pairings/accured/cogs`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },

  async getPairedCreators() {
    try {
      let response = await api.request('get', `/api/v1/pairings/paired/creators`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },

  // get parings by campaign ids
  async getPairedInfluencersByCampaignIDs(campaignIDs) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/pairings/by/campaign-ids', true, {campaignIDs})
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  async getCampaignPaymentStatusSummary(campaignIDs) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/pairings/campaign-payment-status-summary', true, {campaignIDs})
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => reject(error))
    })
  },

  async getSignedInvoices(pairingID) {
    try {
      const response = await api.request('get', `/api/v1/pairings/${pairingID}/signed-invoices`, true)
      if (response.status !== 200) throw new Error('Error')
      return response.data.signedInvoices || []
    } catch (error) {
      throw error
    }
  },

  // get Pairing by handles
  async getPairingsByHandle(handle) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/pairings/by/handle', true, {
          handle
        })
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },

  // get Pairing by influencer ID
  async getPairingsByInfluencerID(influencerID) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/pairings/by/influencerID', true, {
          influencerID
        })
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },

  async updatePairingDetails(pairingID, data) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/${pairingID}/pair-details`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },

  async submitEliminatedInfluencers(eliminationData) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/eliminate/influencer`, true, eliminationData)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },

  async crawlInfluencerDetails(body) {
    try {
      let {
        campaignID,
        userHandle,
        platform,
        platformName,
        options,
        remarks
      } = body
      let response = await api.request('get', `/api/v1/pairings/influencer/detail?campaign=${campaignID}&platform=${platform}&userHandle=${userHandle}&platformName=${platformName}&options=${options}&remarks=${remarks}`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async fetchInfluencerForList(body) {
    try {
      let {
        userHandle,
        platform
      } = body
      let response = await api.request('get', `/api/v1/pairings/fetch/influencer/for-list?platform=${platform}&userHandle=${userHandle}`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },

  async refreshInfluencerDetails(body) {
    try {
      let {
        campaignID,
        ighandle,
        platform,
        pairingID,
        isChange = false
      } = body
      let response = await api.request('get', `/api/v1/pairings/influencer/${encodeURIComponent(ighandle)}/detail/${pairingID}?campaign=${encodeURIComponent(campaignID)}&platform=${encodeURIComponent(platform)}&isChange=${isChange}`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },

  async removePairing(pairingID) {
    try {
      let response = await api.request('delete', `/api/v1/pairings/${pairingID}`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },

  async updatePayoutAmount(data) {
    try {
      let {
        pairingID,
        payoutAmount,
        currency
      } = data
      let response = await api.request('patch', `/api/v1/pairings/${pairingID}/influencers/payout-amount`, true, {
        payoutAmount,
        currency
      })
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return true
    } catch (error) {
      throw error
    }
  },
  async sendListInfluencersToAM(campaignID) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/${campaignID}/send-list-am`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async sendListInfluencersToClient(campaignID) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/${campaignID}/send-list-client`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async sendCOGSExceedReminder(campaignID) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/${campaignID}/send-cogs-exceed-reminder`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async doSelect(pairingID) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/${pairingID}/select`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async doEliminate(pairingID, reason) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/${pairingID}/eliminate`, true, {
        reasonOfElimination: reason
      })
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getInfluencerFromAI(campaignID, force) {
    // retrieve data from State
    let matchParams = store.state.aiMatchParams
    let url = `/api/v1/pairings/campaign/${campaignID}/from-AI?force=${force}&size=${matchParams.size}&minFollowers=${matchParams.minFollowers}&postDate=${matchParams.postDate}`
    try {
      let response = await api.request('post', url, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async updatePairingStatus(data) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/${data.pairingID}/pair-details`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async updatePairingStatusOnly(pairingId, data) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/${pairingId}/update-status`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async saveEditedPairingData(data) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/edited-data`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async saveInfListData(data) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/inf-lists`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async saveEditedCampaignInvite(data) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/edited-invite-data`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
    /**
   * Nyein
   * update Pairings Data
   * @param {*} formData
   * @returns
  */
  updatePairings(formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('PATCH', '/api/v1/pairings/update/data', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  async confirmAdminPayout(data) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/confirm/admin-payout`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async confirmAdminPayoutOnly(pairingID) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/confirm/admin-payout/${pairingID}`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async cancelAdminPayout(pairingID, reasons = '') {
    try {
      let data = {}
      if (reasons) {
        data.reasons = reasons
      }
      let response = await api.request('patch', `/api/v1/pairings/cancel/admin-payout/${pairingID}`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async uploadPayoutInvoice(data) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/upload/payout-invoice`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async updatePayoutHistory(data) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/update/payout-history`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async saveClientNote(data) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/save/client-note`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async saveClientNoteRead(data) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/read/client-note`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async updateClientNote(data) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/update/client-note`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async inviteInfluencerToCampaign(pairingID, inviteData) {
    try {
      const url = `/api/v1/pairings/${pairingID}/send-invite`
      let response = await api.request('patch', url, true, {
        inviteData
      })
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getInvitation(campaignID, influencerID, instagramID, instagramHandle) {
    try {
      const url = `/api/v1/pairings/campaign/${campaignID}/invitation?influencer=${influencerID}`
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getInvitationbyIGHandle(campaignID, instagramHandle) {
    try {
      const url = `/api/v1/pairings/campaign/${campaignID}/invitation?igHandle=${instagramHandle}&platform=instagram`
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getInvitationTikTok(campaignID, handle) {
    try {
      const url = `/api/v1/pairings/campaign/${campaignID}/invitation?tiktokHandle=${handle}&platform=tiktok`
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getInvitationYoutube(campaignID, handle) {
    try {
      const url = `/api/v1/pairings/campaign/${campaignID}/invitation?youtubeHandle=${handle}&platform=youtube`
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getInvitationFacebook(campaignID, handle) {
    try {
      const url = `/api/v1/pairings/campaign/${campaignID}/invitation?fbHandle=${handle}&platform=facebook`
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getInvitationXHS(campaignID, handle) {
    try {
      const url = `/api/v1/pairings/campaign/${campaignID}/invitation?xhsHandle=${handle}&platform=xhs`
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getInvitationOthers(campaignID, handle) {
    try {
      const url = `/api/v1/pairings/campaign/${campaignID}/invitation?otherHandle=${handle}&platform=others`
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getInvitedCampaigns(influencerID, status) {
    try {
      const url = `/api/v1/pairings/campaigns/invited?influencerID=${influencerID}&status=${status}`
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async doAction(pairingID, action) {
    try {
      const url = `/api/v1/pairings/${pairingID}/action/${action}`
      let response = await api.request('patch', url, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getPairedAmount(campaignID, influencerID) {
    try {
      const url = `/api/v1/pairings/${campaignID}/payout?influencerID=${influencerID}`
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async sendClientAcceptedInfluencerListEmailNotify(params) {
    try {
      const url = `/api/v1/posts/client/accepted-influencer-list/notify`
      let response = await api.request('post', url, true, params)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (err) {
      throw err
    }
  },
  async postQuestions(params) {
    try {
      const url = `/api/v1/pairings/inquiry`
      let response = await api.request('post', url, true, params)
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error')
      }
      return response.data
    } catch (err) {
      throw err
    }
  },
  async getQuestions(campaignID, influencerID) {
    try {
      const url = `/api/v1/pairings/inquiry/${campaignID}/${influencerID}`
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (err) {
      throw err
    }
  },
  async putComment(params) {
    try {
      const url = `/api/v1/pairings/inquiry`
      let response = await api.request('patch', url, true, params)
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error')
      }
      return response.data
    } catch (err) {
      throw err
    }
  },
  async triggerEmailToCO(params) {
    try {
      const url = `/api/v1/posts/influencer/questions`
      let response = await api.request('post', url, true, params)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (err) {
      throw err
    }
  },
  // Trigger email to influencer when CO replay their question
  async triggerEmailToInfluencer(params) {
    try {
      const url = `/api/v1/posts/co/reply/questions`
      let response = await api.request('post', url, true, params)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (err) {
      throw err
    }
  },
  async doReject(pairingID, reason) {
    try {
      const url = `/api/v1/pairings/${pairingID}/reject_reason`
      let response = await api.request('patch', url, true, reason)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getAllPairedInfluencer(userID, page, limit) {
    try {
      const url = `/api/v1/pairings/get/all/paired/influencer?userID=${userID}&page=${page}&limit=${limit}`
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getAllPairings(filters = {}) {
    try {
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      const url = `/api/v1/pairings/all/data?${params}`
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getAllPayoutSubmittedPairings() {
    try {
      const url = `/api/v1/pairings/get/all/payout-submitted`
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getPairedInfluencer(pairedID) {
    try {
      const url = `/api/v1/pairings/get/paired/influencer?pairedID=${pairedID}`
      let response = await api.request('get', url, true)

      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getPairedInfluencerOpen(pairedID) {
    try {
      const url = `/api/v1/pairings-open/get/paired/influencer?pairedID=${pairedID}`
      let response = await api.request('get', url, true)

      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getPairedInfluencerStoryBoardOpen(pairedID) {
    try {
      const url = `/api/v1/pairings-open/get/paired/influencer?pairedID=${pairedID}&storyboard=true`
      let response = await api.request('get', url, true)

      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async updatePayoutById(params) {
    try {
      const url = `/api/v1/pairings/paired/influencer/payout`
      let response = await api.request('patch', url, true, params)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      console.log(error)
      throw error
    }
  },
  // Update pairing status send email
  async updateStatusEmail(params) {
    try {
      const url = `/api/v1/pairings/status/update/email`
      let response = await api.request('patch', url, true, params)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      console.log(error)
      throw error
    }
  },
  /**
   * Update into pairing model with brief_details field
   * @param {*} data Pairing ID and brief detail html content
   */
  async updatePairingBriefDetails(data) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/${data.pairingID}/brief-details`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
    /**
   * Update into pairing model with contract field
   * @param {*} data Pairing ID and contract json object content
   */
  async addContracts(data) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/${data.pairingID}/contract`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async sendInfluencerStatusUpdateEmailToCO(params) {
    try {
      const url = `/api/v1/pairings/influencer/status/update/email`
      let response = await api.request('post', url, true, params)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      console.log(error)
      throw error
    }
  },
  async sendContractToInfluencer(formData) {
    try {
      const url = `/api/v1/pairings/influencer/contract/email`
      let response = await api.request('post', url, true, formData)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      console.log(error)
      throw error
    }
  },
  async updateSubmissionAndLiveDates(formData) {
    try {
      const url = `/api/v1/pairings/submission/update`
      let response = await api.request('patch', url, true, formData)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return {
        data: response.data,
        status: response.status
      }
    } catch (error) {
      console.log(error)
      throw error
    }
  },
  async updateSubmissionDate(formData) {
    try {
      const url = `/api/v1/pairings-open/update/submission-date`
      let response = await api.request('patch', url, true, formData)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return {
        data: response.data,
        status: response.status
      }
    } catch (error) {
      console.log(error)
      throw error
    }
  },
  async updateContractAgreement(data) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/${data.pairingID}/contract/agreement`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async sendFollowUpEmail(data) {
    try {
      let response = await api.request('post', '/api/v1/pairings/followup/email', true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  /**
   * Update pairing whith LineUpIndex
   * aung
   */
  async updateLineUpIndex(data) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/${data.pairingID}/lineup`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }

      return response.data
    } catch (error) {
      throw error
    }
  },
  async updateGSTamount(params) {
    try {
      const url = `/api/v1/pairings/GST/update`
      let response = await api.request('patch', url, true, params)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return {
        data: response.data,
        status: response.status
      }
    } catch (error) {
      console.log(error)
      throw error
    }
  },
  async sendSubmissionGuide(param) {
    try {
      const url = '/api/v1/pairings/sendgrid/dynamic/email'
      let data = param
      // console.log('Param data', data)
      let response = await api.request('post', url, true, data)

      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      console.log(error)
      throw error
    }
  },
  async sendEmailSubmittedPost(param) {
    try {
      const url = '/api/v1/pairings/sendgrid/dynamic/email'
      let data = param
      // console.log('Param data', data)
      let response = await api.request('post', url, true, data)

      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      console.log(error)
      throw error
    }
  },
  async getPostUnsubmittedPairingInfluencers(param) {
    try {
      let data = param
      let resp = await api.request('POST', '/api/v1/pairings/unsubmitted/influencers', true, data)
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong')
    } catch (error) {
      throw error
    }
  },
  downloadCampaignPairingsReport(campaignIDs, exportType) {
    return new Promise(function (resolve, reject) {
      api
        .download('/api/v1/pairings/all/download-report', 'POST', {campaignIDs, exportType})
        .then(async (response) => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          // if (exportType === 'csv') {
          //   const blob = new Blob([response.data], {
          //     type: 'utf-8'
          //   })
          //   FileSaver.saveAs(blob, `Creator Payout Report (${utils.func.formatCustomDate(moment(), 'DD MMM YYYY')}).csv`)
          // } else {
          //   const blob = new Blob([response.data], {
          //     type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          //   })
          //   FileSaver.saveAs(blob, `Creator Payout Report (${utils.func.formatCustomDate(moment(), 'DD MMM YYYY')}).xlsx`)
          // }
          if (exportType === 'csv') {
            const blob = new Blob([response.data], {
              type: 'utf-8'
            })
            FileSaver.saveAs(blob, response.headers.filename)
          } else if (exportType === 'excel') {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            })
            FileSaver.saveAs(blob, response.headers.filename)
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  async refreshPairingInfFromIMS(campaignID) {
    try {
      let response = await api.request('patch', `/api/v1/pairings/refresh/influencers/from-ims`, true, {
        campaignID
      })
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  createConceptForm(feedback) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/pairings-open/content-scripts', true, feedback)
        .then(response => {
          if (response.status !== 201) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  approveConceptForm(formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/pairings-open/content-scripts/approve', true, formData)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  async getContentScriptByPairingID(pairingID) {
    try {
      let response = await api.request('get', `/api/v1/pairings-open/content-scripts/bypairing/${pairingID}`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getContentScriptVersions(id) {
    try {
      let response = await api.request('get', `/api/v1/pairings-open/content-scripts/${id}/versions`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getContentScriptByinfID(infID) {
    try {
      let response = await api.request('get', `/api/v1/pairings-open/content-scripts/byinf/${infID}`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async setMainVer(id) {
    try {
      let response = await api.request('get', `/api/v1/pairings-open/content-scripts/set-main-ver/${id}`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  createComment(newComment) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/pairings/content-scripts/comments', true, newComment)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  downloadCreatorConceptRpt(filters) {
    return new Promise(function (resolve, reject) {
      api
        .download('/api/v1/pairings/paired/creator-concepts', 'POST', filters)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          FileSaver.saveAs(blob, `creators_concepts_${moment().format('X')}.xlsx`)
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  async sendContentFlowEmail(formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/pairings/content-flow/email', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/views/Pairing/pairingAPIs.js